/**
 * 均匀网格空间哈希：每逻辑步清空重建，用于把碰撞 / 邻近查询
 * 从 O(n) 降到 O(1) 局部查询。仅逻辑层使用。
 */
export class SpatialHash<T> {
  private readonly cells = new Map<number, T[]>();

  constructor(private readonly cell: number) {}

  clear(): void {
    this.cells.clear();
  }

  private key(cx: number, cy: number): number {
    // 32 位混合，负坐标也可用（Map key）。
    return (cx * 73856093) ^ (cy * 19349663);
  }

  insert(x: number, y: number, item: T): void {
    const cx = Math.floor(x / this.cell);
    const cy = Math.floor(y / this.cell);
    const k = this.key(cx, cy);
    let bucket = this.cells.get(k);
    if (!bucket) {
      bucket = [];
      this.cells.set(k, bucket);
    }
    bucket.push(item);
  }

  /** 查询覆盖 (x,y,r) 的所有格子；结果可能重复，用 seen 去重。 */
  query(x: number, y: number, r: number, out: T[]): T[] {
    out.length = 0;
    const x0 = Math.floor((x - r) / this.cell);
    const x1 = Math.floor((x + r) / this.cell);
    const y0 = Math.floor((y - r) / this.cell);
    const y1 = Math.floor((y + r) / this.cell);
    for (let cx = x0; cx <= x1; cx++) {
      for (let cy = y0; cy <= y1; cy++) {
        const bucket = this.cells.get(this.key(cx, cy));
        if (bucket) out.push(...bucket);
      }
    }
    return out;
  }
}
